import React, { useContext } from 'react'

import Divider from './Common/Divider'
import NotesRender from './Common/NotesRender'
import StartAndEndDateTime from './Common/StartAndEndDateTime'
import DefaultSummaryModalFooter from './Common/SummaryModalFooter/DefaultSummaryModalFooter'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import TripContext from 'tripPlanner/contexts/TripContext'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { NoteItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: NoteItem
}

function NoteItemSummary(props: Props) {
  const { item } = props

  const viewAsTemplate = useContext(TripContext)?.viewAsTemplate ?? false

  const { closeModal, goBack } = useModalCallbacks()
  const { title, startDate, endDate, notes } = item

  const hasAdditionalInfo = startDate || endDate

  return (
    <>
      <ModalHeader
        title={title?.trim() || 'Note'}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />

      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={20}>
            {notes && (
              <NotesRender type="compact" fontSize="large" content={notes} />
            )}
            {hasAdditionalInfo && <Divider />}
            <StartAndEndDateTime
              startTitle={endDate ? 'Start date' : 'Date'}
              endTitle="End date"
              item={item}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>

      {!viewAsTemplate && <DefaultSummaryModalFooter item={item} />}
    </>
  )
}

export default NoteItemSummary
